import ThreadReplyItem from '@src/features/shared/community/components/thread/ThreadReplyItem';
import { useThread } from '@src/features/shared/community/context/ThreadContext';
import React, { useLayoutEffect, useRef } from 'react';

interface ThreadReplyListProps {
  className?: string;
  scrollContainerRef?: React.RefObject<HTMLDivElement>;
}

const ThreadReplyList: React.FC<ThreadReplyListProps> = ({ className, scrollContainerRef }) => {
  const {
    threadReplies,
    pinnedChat,
    channel,
    linkPreviewCache,
    isLoggedIn,
    currentUserId,
    currentUserType,
    threadEditingChatId,
    isActionMenuSpOpen,
    currentChatIdSp,
    onChatEditClick,
    onChatDeleteClick,
    onChatReportClick,
    onSetCurrentChatIdSp,
    onPinnedChatMenuClose,
    onPinnedChatLongPress,
    onToggleLinkPreview,
    onPinClick,
    getChatMenuPermission,
    shouldShowUnreadLine,
    initialThreadChatId,
    setInitialThreadChatId,
  } = useThread();

  const chatRefs = useRef<Record<number, HTMLDivElement | null>>({});

  useLayoutEffect(() => {
    if (!initialThreadChatId || threadReplies.length === 0) {
      return;
    }

    const container = scrollContainerRef?.current;
    const targetElement = chatRefs.current[initialThreadChatId];

    if (!container || !targetElement) {
      return;
    }

    targetElement.scrollIntoView({ block: 'center' });

    if (pinnedChat?.id !== initialThreadChatId) {
      targetElement.classList.add('chat-highlight');
    }

    // ポーリング更新のたびに再スクロールされないようリセット
    setInitialThreadChatId?.(undefined);
  }, [initialThreadChatId, threadReplies, scrollContainerRef, setInitialThreadChatId, pinnedChat]);

  return (
    <div className={`flex flex-1 flex-col ${className || ''}`}>
      {threadReplies.map((reply) => (
        <ThreadReplyItem
          key={reply.id}
          reply={reply}
          channel={channel}
          pinnedChat={pinnedChat}
          linkPreviewCache={linkPreviewCache}
          isLoggedIn={isLoggedIn}
          currentUserId={currentUserId}
          currentUserType={currentUserType}
          editingChatId={threadEditingChatId}
          isActionMenuSpOpen={isActionMenuSpOpen}
          currentChatIdSp={currentChatIdSp}
          onChatEditClick={onChatEditClick}
          onChatDeleteClick={onChatDeleteClick}
          onChatReportClick={onChatReportClick}
          onSetCurrentChatIdSp={onSetCurrentChatIdSp}
          onPinnedChatMenuClose={onPinnedChatMenuClose}
          onPinnedChatLongPress={onPinnedChatLongPress}
          onToggleLinkPreview={onToggleLinkPreview}
          onPinClick={onPinClick}
          getChatMenuPermission={getChatMenuPermission}
          shouldShowUnreadLine={shouldShowUnreadLine}
          chatRef={(el) => {
            chatRefs.current[reply.id] = el;
          }}
        />
      ))}
    </div>
  );
};

export default ThreadReplyList;
